<div class="side-panel-layer">
  <button class="backdrop" type="button" tabindex="-1" aria-label="Cerrar panel" (click)="close()"></button>
  <section class="side-panel {{ sidePanel().size }}" role="dialog" aria-modal="true" [attr.aria-labelledby]="'side-panel-title-' + sidePanel().id">
    <header class="header">
      <div class="title-group">
        <h1 class="title" [id]="'side-panel-title-' + sidePanel().id">{{ sidePanel().title ?? '' }}</h1>
        @if (sidePanel().badge; as badge) {
          <div class="badge">
            @if (badge.icon) {
              <img class="badge-icon" [src]="'/icons/' + badge.icon + '.svg'" [alt]="'Ícono de ' + badge.label">
            }
            <span>{{ badge.label }}</span>
          </div>
        }
      </div>
      <button class="close-button" type="button" aria-label="Cerrar panel" (click)="close()">
        <svg aria-hidden="true" viewBox="0 0 24 24">
          <path d="M6 6l12 12M18 6 6 18"></path>
        </svg>
      </button>
    </header>
    <div class="main-content">
      <ng-container *ngComponentOutlet="sidePanel().component; inputs: sidePanel().inputs"></ng-container>
    </div>
  </section>
</div>
